import { useEffect, useState } from "react";
//import axios from "axios";
import api from "../axios/axiosInstance";
/**
 * Hook to fetch students based on classLevel and sectionLevel filters,
 * and return them sorted alphabetically by last name.
 */
const useFilteredStudents = (classLevel, sectionLevel, academicYear) => {
    const [students, setStudents] = useState([]);

    useEffect(() => {



        let url = `${process.env.REACT_APP_BACKEND_URL}/auth/students/`;
        const params = [];

        if (classLevel) params.push(`class_level=${classLevel}`);
        if (sectionLevel) params.push(`section_level=${sectionLevel}`);
        if (academicYear) params.push(`academic_year=${academicYear}`);

        if (params.length > 0) {
            url += `?${params.join("&")}`;
        }

        api
            .get(url, {
                headers: {
                    "Content-Type": "application/json",
                }, withCredentials: true,
            })
            .then((res) => {
                const data = Array.isArray(res.data) ? res.data : [];
                const sorted = data.sort((a, b) =>
                    a.last_name.localeCompare(b.last_name)
                );
                setStudents(sorted);
            })
            .catch((err) => {
                console.error("Error fetching students:", err);
                setStudents([]); // fallback to empty array on error
            });
    }, [classLevel, sectionLevel, academicYear]);

    return Array.isArray(students) ? students : [];
};

export default useFilteredStudents;
